import React from 'react';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { MetaFormFragmentBase } from 'Components/UI/Meta/MetaForm/Components/MetaFormFragmentBase';
import overrides from './metaOverrides';
import { ExpensesLayout } from './expensesLayout';

export const ExpensesContainer = ({ collection, label }) => {
  return (
    <MetaFormInline
      metaOverrideSet={overrides}
      resource={collection.resources().head()}
      layout={ExpensesLayout}
      LayoutProps={{ label }}
      component={MetaFormFragmentBase}
      noIndividualSubmitButtons
    />
  );
};

ExpensesContainer.propTypes = {
  label: PropTypes.string.isRequired,
  collection: PropTypes.object.isRequired,
};
